export default {
    top_menu: [
        {name:'Головне',    id:0},
        {name:'Шоу-бізнес', id:1},
        {name:'Кулінарія',  id:2},
        {name:'Політика',   id:3},
        {name:'Пікантне',  id:4},
        {name:'Суспільство',   id:5},
        {name:"Здоров'я",   id:6},
    ],
    read_other: 'Читати далі',
    read_more:  'Детальніше',
    not_found:  'Нічого не знайдено',
    read_also:  'Читайте також',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Всі права захищені.',
    subscribe: 'Підписатися',
    thank_order: 'ДЯКУЮ ЗА ЗАМОВЛЕННЯ',
    specialist_contact: "Наш фахівець скоро зв'яжеться з вами, очікуйте нашого дзвінка.",
    attention: 'Знижки від партнерів:',
    hurry: 'Поспішайте, час активації знижки обмежена! У вас є всього <span id="time" class="time">30:00</span> хвилин, щоб вибрати один з цих унікальних товарів:',
    hour_ago1: "годину тому",
    hour_ago2: "години назад",
    hour_ago3: "годин назад",
    new_publications: "нові публікації",
    read: "Читати",
    today_at: "Сьогодні в",
    author_names: ['Тина Король','Сергей Притула','Ольга Полякова'],
    main_news: "Головні новини",
    leave_already: "Вже йдете? Зачекайте, ми оновили для Вас новини",
    already_shared: "вже поділилися"
}